import { Viewport } from 'components/ViewportProvider';
// import MainCategoryNavMobile from 'containers/MainCategoryMobile';
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import StarIcon from './GuaranteeImgs/StarIcon';

import './topNav.css';

interface IHeaderBottomProps extends RouteComponentProps {
  setShowTopHeaderCallback: (state: boolean) => void;
}

type Props = IHeaderBottomProps;

export const CategoryIconWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 10px 16px;
  font-size: 15px;
  color: #424242;
  border: 1px solid rgba(189, 189, 189, 0.6);
  height: fit-content;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #fafafa;
    font-weight: 500;
    border-color: rgba(189, 189, 189, 0.6);
  }

  ${({ isActive }) =>
    isActive &&
    `
    color: #4caf50;
    border-color: #4CAF50 !important;
    background: #fafafa;
    div div svg {
      filter: invert(53%) sepia(9%) saturate(3454%) hue-rotate(73deg) brightness(99%) contrast(68%);
    }
  `}
`;
export const LanguageItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const GuaranteeBar = styled.div`
  background: #15803d;
  width: 100%;
  @media (max-width: 991px) {
    background: rgb(67, 160, 71);
    overflow: hidden;
  }
`;

const GuaranteeBarInner = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 8px 64px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SlideItem = styled.div`
  @media (min-width: 992px) {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
  text-align: center;
`;

const IconWrapper = styled.div`
  @media (max-width: 991px) {
    display: none;
  }
`;

const SlideText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  white-space: nowrap;
  @media (max-width: 991px) {
    font-size: 12px;
    line-height: 20px;
  }
`;

const SlideViewMoreText = styled.a`
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  &:hover {
    color: #ffffff;
    opacity: 0.9;
  }
  @media (max-width: 991px) {
    font-size: 12px;
    line-height: 20px;
  }
`;

const StyledSwiper = styled(Swiper)`
  width: 100%;
  max-width: 480px;
  position: relative;
  @media (min-width: 992px) {
    display: flex !important;
    align-items: center;
  }
  .swiper-pagination {
    @media (min-width: 992px) {
      position: absolute;
      right: 0;
      top: 0px !important;
      left: unset !important;
    }
    @media (max-width: 991px) {
      margin: 8px auto 0;
      background: rgb(67, 160, 71);
      position: unset !important;
    }
    z-index: 1;
    margin-top: 0;
    display: flex;
    align-items: center;
    gap: 4px;
    width: fit-content !important;
    flex-shrink: 0;
    height: 100%;
    background: #15803d;
  }
  .swiper-pagination-bullet {
    background: rgba(255, 255, 255, 0.5);
    opacity: 1;
    width: 4px;
    height: 4px;
    margin: 0 !important;
  }
  .swiper-pagination-bullet-active {
    background: #ffffff;
    width: 12px;
    border-radius: 80px;
  }
  .swiper-slide {
    width: 100% !important;
  }
`;

const SwiperWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ArrowRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M5.1714 0.94822L9.65623 5.32931H0V6.67069H9.65623L5.1714 11.0518L6.14208 12L11.7988 6.47411C12.0671 6.21207 12.0671 5.78793 11.7988 5.52589L6.14208 0L5.1714 0.94822Z"
        fill="white"
      />
    </svg>
  );
};

const HomePageBottomHeader: FC<Props> = (props) => {
  const { location, setShowTopHeaderCallback } = props;

  // const [showTopHeader, setShowTopHeader] = useState(true);
  const lastScrollTop = useRef(0);
  const [scrollProgress, setScrollProgress] = useState(0);
  const lang = localStorage.getItem('lang') || 'vi';

  const guaranteeData = useMemo(() => {
    return [
      {
        text:
          lang === 'vi'
            ? 'Tại sao hơn 5,000 doanh nghiệp F&B chọn Kamereo?'
            : 'Why 5,000+ F&B businesses choose Kamereo?',
        Icon: StarIcon,
        viewMore: (
          <SlideViewMoreText
            target="_blank"
            rel="noopener noreferrer"
            href={lang === 'vi' ? 'https://kamereo.vn/ve-kamereo' : 'https://kamereo.vn/about-kamereo'}
          >
            {lang === 'vi' ? 'Tìm hiểu' : 'Learn more'}
            {` `}
            <ArrowRight />
          </SlideViewMoreText>
        ),
      },
    ];
  }, [lang]);

  const isHomePage = location.pathname === '/';
  const onScroll = useCallback(() => {
    requestAnimationFrame(() => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;

      // 1) scroll progress
      setScrollProgress((scrollTop / docHeight) * 100);

      // 3) show/hide top header
      if (scrollTop > lastScrollTop.current && scrollTop > 100) {
        setShowTopHeaderCallback(false);
      } else {
        setShowTopHeaderCallback(true);
      }

      lastScrollTop.current = scrollTop;
    });
  }, [setShowTopHeaderCallback]);

  useEffect(() => {
    if (!isHomePage) return;

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [isHomePage, onScroll]);

  return (
    <div>
      {isHomePage && (
        <Viewport.Consumer>
          {({ width }) => {
            const isTablet = width < 992;
            return (
              <GuaranteeBar style={{ display: scrollProgress === 0 || isTablet ? 'block' : 'none' }}>
                <GuaranteeBarInner>
                  <SwiperWrapper>
                    <StyledSwiper
                      modules={[Autoplay, Pagination]}
                      autoplay={{ delay: 3000, disableOnInteraction: false }}
                      pagination={{ clickable: true }}
                      loop
                      slidesPerView={1}
                    >
                      {guaranteeData.map((item) => (
                        <SwiperSlide key={item.text}>
                          <SlideItem>
                            <IconWrapper>
                              <item.Icon />
                            </IconWrapper>
                            <SlideText>{item.text}</SlideText>
                            {` `}
                            {item.viewMore}
                          </SlideItem>
                        </SwiperSlide>
                      ))}
                    </StyledSwiper>
                  </SwiperWrapper>
                </GuaranteeBarInner>
              </GuaranteeBar>
            );
          }}
        </Viewport.Consumer>
      )}
    </div>
  );
};

export default withRouter(HomePageBottomHeader);
